import AppLoader from 'components/AppLoader';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import UserAPI from 'restAPI/UserAPI';
import { type FeatureFlagValues, FeatureKeys } from 'types/api/featureFlags';

export { FeatureKeys };
export type FeatureFlagContentValuesType = FeatureFlagValues;

// used the same object so that it is available in popups as well.
const FeatureFlagContentValues: FeatureFlagContentValuesType = Object.keys(
  FeatureKeys,
).reduce(
  (ffObj, key) => {
    ffObj[key as FeatureKeys] = false;
    return ffObj;
  },
  {} as unknown as FeatureFlagContentValuesType,
);

const FeatureFlagContext = React.createContext(FeatureFlagContentValues);

export function useFeatureFlag() {
  return useContext(FeatureFlagContext);
}

function FeatureFlagProvider(props: {
  children: React.ReactNode[] | React.ReactNode;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { promise, cancel } = UserAPI.getFeatureFlags();

    promise
      .then((data) => {
        buildContextValue(data);
        setLoading(false);
      })
      .finally(() => setLoading(false));

    return cancel;
  }, []);

  if (loading) {
    return <AppLoader />;
  }
  return (
    <FeatureFlagContext.Provider value={FeatureFlagContentValues}>
      {props.children}
    </FeatureFlagContext.Provider>
  );
}

function buildContextValue(treatments: FeatureFlagContentValuesType) {
  for (const i in FeatureKeys) {
    const key = i as FeatureKeys;
    const ffvalue = treatments[FeatureKeys[key]];
    if (ffvalue) {
      FeatureFlagContentValues[key] = true;
    }
  }
}

export default FeatureFlagProvider;

export function withFeatureFlags(
  Component: React.ComponentType<{
    featureFlags: FeatureFlagContentValuesType;
  }>,
) {
  return function FeatureFlagHOC(props: { [key: string]: unknown }) {
    const featureFlags = useFeatureFlag();
    return <Component {...props} featureFlags={featureFlags} />;
  };
}

export function getFeatureFlags_UNSAFE() {
  return cloneDeep(FeatureFlagContentValues);
}
